<template>
  <v-container fluid class="auth-page">
    <v-container class="auth-shell">
      <v-card elevation="0" class="auth-card rounded-xl">
        <v-container class="auth-form-panel">
            <div class="auth-logo-wrap">
              <img src="@/assets/mtl-cargo-logo-2.png" class="auth-logo" />
            </div>
            <div class="auth-form-header">
              <div class="auth-eyebrow">Get Started</div>
              <h2>User Registration</h2>
              <p>Fill in your account details below.</p>
            </div>

            <template v-if="!isSuccessful">
              <v-form ref="form" v-model="isFormValid">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      dense
                      rounded
                      outlined
                      :rules="nameRules"
                      v-model="first"
                      label="First Name"
                      prepend-inner-icon="mdi-account-outline"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      dense
                      rounded
                      outlined
                      :rules="nameRules"
                      v-model="last"
                      label="Last Name"
                      prepend-inner-icon="mdi-account-outline"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-text-field
                  dense
                  rounded
                  outlined
                  :rules="emailRules"
                  v-model="email"
                  label="Email"
                  prepend-inner-icon="mdi-email-outline"
                  required
                ></v-text-field>
                <v-text-field
                  dense
                  rounded
                  outlined
                  v-model="phone"
                  label="Phone"
                  prepend-inner-icon="mdi-phone-outline"
                  required
                ></v-text-field>
                <v-text-field
                  dense
                  rounded
                  outlined
                  :rules="passRules"
                  type="password"
                  v-model="password"
                  label="Password"
                  prepend-inner-icon="mdi-lock-outline"
                  required
                ></v-text-field>
                <v-text-field
                  dense
                  rounded
                  outlined
                  :rules="passRules"
                  type="password"
                  v-model="confPassword"
                  label="Confirm Password"
                  prepend-inner-icon="mdi-lock-check-outline"
                  required
                ></v-text-field>
              </v-form>

              <div class="auth-actions">
                <v-btn depressed rounded color="warning" @click="clear">
                  <i class="fas fa-times mr-2"></i>
                  Clear
                </v-btn>
                <v-btn
                  depressed
                  rounded
                  color="primary"
                  @click="register"
                  :disabled="!isFormValid"
                  :loading="isLoading"
                >
                  <i class="far fa-save mr-2"></i>
                  Register
                </v-btn>
              </div>
            </template>

            <div class="success-panel text-center" v-else>
              <v-icon size="52" color="success">mdi-check-circle</v-icon>
              <h3>You are almost done</h3>
              <p>
                We sent a verification link to your email. Check your inbox to
                finish setting up your account.
              </p>
            </div>

            <div class="auth-switch">
              <span>Already have an account?</span>
              <v-btn
                text
                small
                color="primary"
                @click="$router.push({ name: 'Login' }).catch(() => {})">
                Login
              </v-btn>
            </div>
          </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service.js";
import generalMixin from "@/js/general-mixin";
import eventBus from "../js/event-bus.js";
import formMixin from "@/js/form-mixin.js";
export default {
  name: "UserRegister",
  mixins: [formMixin, generalMixin],
  data() {
    return {};
  },
  methods: {
    clear() {
      this.clearVariables();
      this.$refs.form.resetValidation();
    },
    register() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let account = {};
      account.first = this.first;
      account.last = this.last;
      account.email = this.email;
      account.password = this.password;
      account.phone = this.phone;
      this.isLoading = true;
      backendService
        .registerUser(account)
        .then(() => {
          this.timer(1000).then(() => {
            eventBus.$emit(
              "setSnackbar",
              "User Successfully Register",
              "success",
              true
            );
            this.clear();
            this.isLoading = false;
            this.isSuccessful = true;
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            eventBus.$emit(
              "setSnackbar",
              "Ops! Something is not right!",
              "red",
              true
            );
            this.isLoading = false;
          });
        });
    },
  },
};
</script>
<style scoped>
.auth-page {
  align-items: center;
  display: flex;
  min-height: calc(100vh - 128px);
  padding: 24px 12px;
}
.auth-shell {
  max-width: 560px;
  padding: 0;
}
.auth-card {
  overflow: hidden;
}
.auth-form-header p,
.success-panel p {
  font-size: 15px;
  line-height: 1.55;
  margin: 0;
}
.auth-eyebrow {
  color: #f6a03d;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}
.auth-form-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 34px 36px 32px;
}
.auth-logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.auth-logo {
  max-width: 154px;
  width: 44%;
}
.auth-form-header {
  text-align: center;
  margin-bottom: 20px;
}
.auth-form-header h2 {
  color: #172033;
  font-size: 28px;
  font-weight: 650;
  line-height: 1.2;
  margin: 6px 0 8px;
}
.auth-form-header p,
.auth-switch,
.success-panel p {
  color: #667085;
}
.auth-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
}
.success-panel {
  background-color: #f7fbf8;
  border: 1px solid #d8efdd;
  border-radius: 22px;
  padding: 28px 20px;
}
.success-panel h3 {
  color: #172033;
  font-size: 22px;
  font-weight: 650;
  margin: 12px 0 8px;
}
.auth-switch {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: center;
  margin-top: 18px;
}
@media (max-width: 959px) {
  .auth-page {
    min-height: auto;
  }
  .auth-form-panel {
    padding: 30px 22px;
  }
}
@media (max-width: 599px) {
  .auth-actions {
    flex-direction: column-reverse;
  }
  .auth-actions .v-btn {
    width: 100%;
  }
}
</style>
